import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";

import {
  GetBannerResponseType,
  GetPromotionChanllengeResponse,
  GetPromotionDataResponse,
  GetPromotionListResponse,
} from "./type";

export const retrieveApi = {
  // async getPromotionList() {
  //   const { data } = await axiosRequest.post<GetPromotionListResponse>(
  //     "/",
  //     payloadHelper("PromotionList", null, null)
  //   );
  //   return data;
  // },
  // async getPromotionList(category_id: number) {
  //   const { data } = await axiosRequest.post<GetPromotionListResponse>(
  //     "/",
  //     payloadHelper("CategoryPromotionList", null, { category_id })
  //   );
  //   return data;
  // },
  async getPromotionList(category_id: number) {
    const { data } = await axiosRequest.post<GetPromotionListResponse>(
      "/",
      payloadHelper("CategoryPromotionList2", null, {
        category_id,
        project: "bajigold",
      })
    );
    return data;
  },
  async getBanner() {
    const { data } = await axiosRequest.post<GetBannerResponseType>(
      "/",
      payloadHelper("Banner", null, null)
    );
    return data;
  },
  async getPromotionChanllenge(username: string) {
    const { data } = await axiosRequest.post<GetPromotionChanllengeResponse>(
      "/",
      payloadHelper("PromotionChanllenge", username, { username })
    );
    return data;
  },

  async getPromotionData(promotion_id: number) {
    const { data } = await axiosRequest.post<GetPromotionDataResponse>(
      "/",
      payloadHelper("PromotionData", null, { promotion_id })
    );
    return data;
  },
};
